import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, Link } from 'react-router-dom';
import DataTable from 'react-data-table-component';

import { buscarVueltas } from '../../actions/vueltas';
import { buscarSucursales } from '../../actions/sucursales';
import { buscarEmpleados } from '../../actions/empleados';
import { buscarEventos } from '../../actions/eventos';
import { buscarProductosConfiguracion } from '../../actions/configuracion';
import { editarBreadcrumb } from '../../actions/breadcrumb';
import { formatNumber } from '../../utils/generalFunctions';

import FiltrosVuelta from './FiltrosVuelta';

const formatNombre = (persona) => persona
    ? `${persona.nombre || ''} ${persona.apellido_paterno || ''} ${persona.apellido_materno || ''}`.trim()
    : '-';

const filtrosVacios = {
    folio: '',
    fecha_inicio: null,
    fecha_fin: null,
    status: null,
    sucursal: null,
    vendedor: null,
    responsable: null,
    evento: null,
    productos: []
};

const Vueltas = () => {

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const listado = useSelector(state => state.vueltas.listado);

    const [filtrosModal, setFiltrosModal] = useState(false);
    const [filtros, setFiltros] = useState(filtrosVacios);

    useEffect(() => {
        dispatch(buscarVueltas(filtrosVacios));
        dispatch(buscarSucursales());
        dispatch(buscarEmpleados());
        dispatch(buscarEventos(false));
        dispatch(buscarProductosConfiguracion());
        dispatch(editarBreadcrumb([
            { nombre: 'Ventas ambulantes', path: '/vueltas', activo: true }
        ]));
    }, []);

    const handleAplicarFiltros = (nuevosFiltros) => {
        setFiltros(nuevosFiltros);
        dispatch(buscarVueltas(nuevosFiltros));
    };

    const filtrosActivos = [
        filtros.folio,
        filtros.fecha_inicio,
        filtros.fecha_fin,
        filtros.status !== null,
        filtros.sucursal,
        filtros.vendedor,
        filtros.responsable,
        filtros.evento,
        filtros.productos?.length > 0
    ].filter(Boolean).length;

    const columns = [
        {
            name: 'Folio',
            sortable: true,
            selector: row => row.folio || '-'
        },
        {
            name: 'Fecha',
            sortable: true,
            selector: row => row.fecha
                ? new Date(row.fecha).toLocaleString('es-MX', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' })
                : '-',
            grow: 1.5
        },
        {
            name: 'Total',
            sortable: true,
            selector: row => row.total != null ? formatNumber(row.total, 2, '$', '') : '-'
        },
        {
            name: 'Status',
            sortable: true,
            cell: row => (
                <span className={`badge ${row.status === true ? 'bg-success' : 'bg-warning text-dark'}`}>
                    {row.status === true ? 'Finalizada' : 'Pendiente'}
                </span>
            )
        },
        {
            name: 'Sucursal',
            sortable: true,
            selector: row => row.sucursal?.nombre || '-',
            grow: 1.5
        },
        {
            name: 'Vendedor',
            sortable: true,
            selector: row => formatNombre(row.vendedor),
            grow: 1.5
        },
        {
            name: 'Responsable',
            sortable: true,
            selector: row => formatNombre(row.responsable),
            grow: 1.5
        },
        {
            name: 'Evento',
            sortable: true,
            selector: row => row.evento?.nombre || '-',
            grow: 1.5
        },
        {
            name: 'Acciones',
            cell: row => (
                <Link className="btn btn-sm btn-info" to={`/vueltas/informacion/${row._id}`}>
                    <i className="fas fa-eye"></i>
                </Link>
            )
        }
    ];

    return (
        <div className="row mt-5">
            <div className="col-12 mb-4 d-flex justify-content-between align-items-center">
                <h4 className="mb-0">Ventas ambulantes</h4>
                <button className="btn btn-secondary position-relative" onClick={() => setFiltrosModal(true)}>
                    <i className="fas fa-filter me-1"></i> Filtros
                    {filtrosActivos > 0 && (
                        <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-primary">
                            {filtrosActivos}
                        </span>
                    )}
                </button>
            </div>

            <div className="col-12">
                <DataTable
                    columns={columns}
                    data={listado}
                    pagination
                    paginationPerPage={20}
                    paginationComponentOptions={{ rowsPerPageText: 'Filas por página', rangeSeparatorText: 'de' }}
                    highlightOnHover
                    noDataComponent="No hay ventas ambulantes registradas"
                />
            </div>

            <FiltrosVuelta
                show={filtrosModal}
                handleCerrar={() => setFiltrosModal(false)}
                filtros={filtros}
                handleAplicar={handleAplicarFiltros}
            />
        </div>
    );
};

export default Vueltas;
